import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { getDashboardData } from "../../services/dashboardServices";
import AddUserModal from "./AddUserModal";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      DataisLoaded: false,
      solution: false,
      settings: false,
      showUserModal:false,
    };
 

  }

  componentDidMount() {
    getDashboardData().then((json) => {
      this.setState({
        items: json,
        DataisLoaded: true,
      });
    });
  }

  openSolution = () =>{
    this.setState( prevState => ({solution: !prevState.solution}))
  }

  openSettings = () =>{
    this.setState( prevState => ({settings: !prevState.settings}))
  }

  

  nextPath(path) {
    this.props.history.push(path);
  }


  unhideColors(){
    
  }

  setShowUserModal(){
    this.setState({showUserModal:false})
  };

  
  render() {

    const {  items } = this.state;


    const { xdr_edr, xdr, xdr_cm, xdr_tm, xdr_soar,compliance_gsos,compliance, xdrp, xdrp_nd, xdrp_pm, oxdr, oxdr_asm, oxdr_bas, oxdr_ro, oxdr_vm, oxdr_phish , admin_role , configuration_role} = { ...this?.props?.posts[0] };


 

    const renderMenuItems = () => {
      const serviceItems = [
        {
          conditions: (xdr=== true || xdr_edr === true || xdr_cm === true || xdr_soar === true|| xdr_tm === true),
          name: "xdr",
          id: "xdr-box1",
          colorClass: "xdr-circle-bg1",
          link: "/xdr",
          serviceName: "XDR",
          serviceDescription: "Defender's Brain",
        },
        {
          conditions: (xdrp === true || xdrp_nd  === true|| xdrp_pm  === true),
          name: "xdrp",
          id: "xdr-box2",
          colorClass:"xdr-circle-bg2",
          link: "/xdrp",
          serviceName: "XDR+",
          serviceDescription: "Attacker's Mind",
        },
        {
          conditions: (oxdr === true || oxdr_asm  === true || oxdr_bas  === true || oxdr_ro === true || oxdr_vm === true || oxdr_phish === true),
          name: "oxdr",
          id: "xdr-box3",
          colorClass:"xdr-circle-bg3",
          link: "/oxdr",
          serviceName: "OXDR",
          serviceDescription: "Attacker's Action",
        },
        {
          conditions: (compliance || compliance_gsos),
          name: "compliance",
          id: "xdr-box4",
          colorClass:"xdr-circle-bg4",
          link: "/compliance",
          serviceName: "GSOS",
          serviceDescription: "Compliance Platform",
        },
      ];

      return serviceItems.map((item, index) => (
        
        (item.conditions) && (
        <div key={index} className={
          this.props.team === item.name
            ? "nav-item active"
            : "nav-item"
        } >
        <NavLink  to={item.link}>
        <div className="xdr-box xdr-link" id={item.id}> 
            <div className="d-flex align-items-center">       
              <div className={`xdr-circle ${item.colorClass}`}></div>
              <div className="xdr-name">
                <p>{item.serviceName}</p>
                <p>{item.serviceDescription}</p>
              </div>
            </div>
              {this.props.team === item.name && <div className="xdr-right-icon">
                <img src="images/chevron_right.png" />
              </div>}
            </div>
        </NavLink>
        </div>)
        
      ));
    };


    return (
      <>
      
       <div className="ham-menu">
          <div className="hamburger" >
            <img src="images/hamburger.png" id="bar"  onClick={this.openSolution} />
            <img src="images/close.png" id="close"/>
          </div>
          {admin_role  && <div className="set-hamburger-btn">
            <img src="images/setting.png" id="set-bar" onClick={this.openSettings} />
            <img src="images/close.png" id="set-close" />
          </div>}
        </div>
        <div className="sidebar-column ">
          <div className={this.state.solution === false? "sidebar sidebar-1" : "sidebar" } id="sidebar-1">
            <div className="side-head">
              
            </div>
             {renderMenuItems()}
          </div>
          {admin_role  && <>
          <div className={this.state.settings === false? "sidebar sidebar-2" : "sidebar" } id="sidebar-2">
            <div className="user-head">
              <h4 class="heading-2">User Management</h4>
            </div>

           
            {/* {items && (<a href={items[items.length - 1]?.link}> */}

            {/* <NavLink to="/add-user"> */}
              {/* <div className="user-management" style={{cursor:"pointer"}} onClick={()=>{this.setState({showUserModal:true})}}>
                <div className="user-icon"><img src="images/add-user.png" /></div>
                <p>Add new user</p>
              </div> */}
            {/* </NavLink> */}
            {/* </a>)} */}

            <NavLink to="/users">

            <div className="user-management">
              <div className="user-icon"><img src="images/add-user.png" /></div>
              <p>Manage users</p>
            </div></NavLink>

            

            <NavLink to="/reports">
            <div className="user-management">
              <div className="user-icon"><img src="images/user.png" /></div>
              <p>Reports</p>
              
            </div></NavLink>
          </div>
          
          {
            configuration_role && <NavLink to="/settings">
            <div className={this.state.settings === false? "setting sidebar-2" : "setting" }>
              <div className="setting-icon"><img src="images/setting.png" /></div>
              <p>Configuration</p>
            </div>
            </NavLink>
          }
          </>
          }
        </div>
        
        <AddUserModal 
          show={this.state.showUserModal}
          onHide={() => this.setShowUserModal()}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { posts: state.posts };
};

export default connect(mapStateToProps)(Sidebar);
